interface IProps {
  ariaLabel: string
  disabled: boolean
  saving: boolean
  onClick: () => void
}

export const SaveButton = ({ ariaLabel, disabled, saving, onClick }: IProps) => (
  <button
    type='button'
    className='btn btn-sm btn-solid-primary text-nowrap'
    aria-label={ariaLabel}
    disabled={disabled || saving}
    onClick={onClick}
  >
    {saving ? (
      <span className='indicator-progress' style={{ display: 'block' }}>
        Guardando...
        <span className='spinner-border spinner-border-sm align-middle ms-2' />
      </span>
    ) : (
      'Guardar'
    )}
  </button>
)
